/* eslint-disable func-names, default-case */

import { geolocate } from './utility';

export default {
  'map-in-view': function () {
    this.lazyMount();
  },

  'map-loaded': function (e) {
    this.map = e.detail;

    this.locations.forEach((location) => {
      this.map.addMarker(location.marker);
    });

    this.map.refreshBounds();

    if (!this.ignoreQueryParams) {
      this.handleQueryParams();
    }

    this.presetFilters();
    this.attachMapListeners();
  },

  'query-params-handled': function () {
    geolocate();
  },

  'map-user-pin-added': function () {
    this.map.calcDistances();
    this.updateDistances();
    this.sortLocationsByDistance();
    this.updateListings().then(() => {
      // Select the closest, visible location
      const closestLocation = this.locations.find(
        (location) => !location.isHidden(),
      );
      this.activePage = closestLocation;
      this.activePage.card.click();
    });
  },

  'location-selected': function (e) {
    this.activeLocation = e.detail;
    const { marker } = this.activeLocation;

    this.map.flyTo(marker, {
      zoom: 10,
    });
  },

  'filter-selected': function (e) {
    const filter = e.detail;

    this.filteredLocations = filter.apply(this.locations, this.filters);

    this.filters.vehicleType?.setOptions(this.uniqueVehicleTypes());
    this.filters.department.setOptions(this.uniqueDepartments());

    if (!this.handlingQueryParams) {
      this.refresh();
    }
  },

  'filter-cleared': function (e) {
    const clearedFilter = e.detail;

    // if only one filter was set, return both to their default states
    if (!this.allFiltersSet() || this.filterCount() === 1) {
      this.resetFilters();
      this.filteredLocations = [];
      this.refresh();
      return;
    }

    const filterToReapply = clearedFilter.is('vehicleType')
      ? this.filters.department
      : this.filters.vehicleType;

    clearedFilter.reset();
    this.filters.department.setOptions(this.uniqueDepartments());
    this.filters.vehicleType?.setOptions(this.uniqueVehicleTypes());

    this.filteredLocations = filterToReapply.apply(this.locations);
    clearedFilter.selectDefault();
    this.refresh();
  },

  'marker-clicked': function (e) {
    if (this.mapOnly) return;

    const marker = e.detail;
    const locationsToCheck = this.hasFilteredLocations()
      ? this.filteredLocations
      : this.locations;

    this.activeLocation = locationsToCheck.find(
      (location) => location.id === marker.id,
    );
    this.activeLocation.activate();
    this.activeLocation.scrollTo();
  },
};
